import { BrowserRouter } from 'react-router-dom';
import { UserProvider } from './context/UserContext';
import { ThemeProvider } from './context/ThemeProvider';
import { ToastProvider } from './context/ToastProvider';
import { BatchProgressProvider } from './context/BatchProgressContext';
import DynamicLocaleProvider from './context/DynamicLocaleProvider';
import AuthView from './components/AuthView';
import BatchProgressIndicator from './components/BatchProgressIndicator';

function App() {
  return (
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <UserProvider>
        <ThemeProvider>
          <ToastProvider>
            <BatchProgressProvider>
              <DynamicLocaleProvider>
                <AuthView />
                <BatchProgressIndicator />
              </DynamicLocaleProvider>
            </BatchProgressProvider>
          </ToastProvider>
        </ThemeProvider>
      </UserProvider>
    </BrowserRouter>
  );
}

export default App;

